import React, { useState } from 'react';
import ApplicationForm from './ApplicationForm';

function ApplicationPageMainContainer() {
  return (
    <main className='grid gap-12 pb-12 pt-10'>
      <article className='grid gap-4 px-6 sm:px-10 md:px-16'>
        <h1 className='text-3xl font-bold text-center mb-4'>
          Mistress Sammi TS - Sub Application
        </h1>
        <p className='text-center text-sm'>
          Complete this form to apply for a session. Be honest and respectful.
        </p>
      </article>

      {/* Form */}
      <ApplicationForm />
    </main>
  );
}

export default ApplicationPageMainContainer;
